import React, { useEffect, useState } from 'react'
import PropTypes, { array } from 'prop-types'
import RequestHistoryFile from './RequestHistoryFile'
import DeleteAccountHistory from './DeleteAccountHistory'
import { connect } from 'react-redux'
import { resetVerifiedUser } from '../redux/actions'
import DataSource from '../DataSource'
import ModuleWithLoader from './ModuleWithLoader'
import globals from '../globals'

const HomeSecureAccountHistory = (props) => {
    const [isLoaded, setIsLoaded] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [downloadRequests, setDownloadRequests] = useState([])
    const [deleteRequests, setDeleteRequests] = useState([])

    useEffect(() => {
        DataSource.getData(`/api/getGdprRequests/${props.serviceId}`, response => {
            setIsLoaded(true)
            if (Array.isArray(response)) {
                setDownloadRequests(response.filter(val => val.transactionType === 'request'))
                setDeleteRequests(response.filter(val => val.transactionType === 'delete'))
            }
        }, error => {
            setIsLoaded(true)
            if (error.response.status === 422 || error.response.status === 401) {
                handleExpiredToken()
            } else {
                setHasError(true)
                globals.handleError('Error occurred when trying to pull GDPR requests', { error: error })
            }
        })
    }, [])

    const handleExpiredToken = () => {
        props.resetVerifiedUser()
    }

    return (
        <ModuleWithLoader isLoaded={isLoaded} hasError={hasError}>
            <div className='hs-account-history'>
                <div className='row'>
                    <div className='col-12 col-md-8 offset-md-2 text-center mb-4'>
                        <p className='m-0 mb-2 bold font-large'>Download or delete your Home Secure account history</p>
                    </div>
                    <div className='col-12 col-lg-3 offset-lg-3 d-flex justify-content-center justify-content-lg-end mr-lg-4 mb-5 mb-lg-0'>
                        <RequestHistoryFile
                            serviceId={props.serviceId}
                            requests={downloadRequests}
                            handleExpiredToken={handleExpiredToken}
                        />
                    </div>
                    <div className='col-12 col-lg-3 text-center text-lg-left'>
                        <DeleteAccountHistory
                            serviceId={props.serviceId}
                            requests={deleteRequests}
                            handleExpiredToken={handleExpiredToken}
                        />
                    </div>
                </div>
            </div>
        </ModuleWithLoader>
    )
}

HomeSecureAccountHistory.propTypes = {
    serviceId: PropTypes.number.isRequired
}

const mapStateToProps = state => ({
    isVerified: state.verifiedUser.isVerified,
    verifiedToken: state.verifiedUser.verifiedToken
})

export default connect(mapStateToProps, { resetVerifiedUser })(HomeSecureAccountHistory)



// WEBPACK FOOTER //
// ./resources/js/components/HomeSecureAccountHistory.js